import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export enum HomepageRedirectTarget {
  OnboardingError = "onboardingError",
}

type HomepageRedirectState = {
  target: HomepageRedirectTarget | null;
  setTarget: (target: HomepageRedirectTarget | null) => void;
}

export const useHomepageRedirect = create<HomepageRedirectState>()(
  persist(
    set => ({
      target: null,
      setTarget: target =>
        set({
          target,
        }),
    }),
    {
      storage: createJSONStorage(() => localStorage),
      name: "homepage-redirect",
    },
  ),
);
